import { create, select } from "../_utils";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import locale from "../locale/it.json";
import diapason from "./../images/guitars/boom/diapason/diapason_cover.jpg";
import diapasonPickUp from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Pick-up a manico.jpg";
import diapasonBridge from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Ponte.jpg";
import diapasonKeyboard from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Tastiera.jpg";
import tretrecinque from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_principlale.jpg";
import tretrecinqueKeyboard from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Segnatasti.jpg";
import tretrecinquePickUp from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Pick up.jpg";
import tretrecinqueBridge from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Ponte.jpg";
import venere from "./../images/guitars/roar/venere/ROAR_VENERE_principale.jpg";
import venereBridge from "./../images/guitars/roar/venere/ROAR VENERE_Ponte.jpg";
import venerePickUp from "./../images/guitars/roar/venere/ROAR_VENERE_Pickup.jpg";
import venereKeyboard from "./../images/guitars/roar/venere/ROAR_VENERE_Segnatasti.jpg";
import mono from "./../images/guitars/slurp/mono/SLURP_MONO_principale.jpg";
import monoPickup from "./../images/guitars/slurp/mono/SLURP_MONO_pickup.jpg";
import monoNeck from "./../images/guitars/slurp/mono/SLURP_MONO_Manico.jpg";
import monoMark from "./../images/guitars/slurp/mono/SLURP_MONO_Marchio.jpg";
import pinderbass from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_principale.jpg";
import pinderbassBridge from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_Ponte.jpg";
import pinderbassWoods from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_legni.jpg";
import pinderbassEq from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_Equalizzazione.jpg";
import klein from "./../images/guitars/wow/klein/WOW_KLEIN_principale.jpg";
import kleinPickUp from "./../images/guitars/wow/klein/WOW_KLEIN_Pickup.jpg";
import kleinBridge from "./../images/guitars/wow/klein/WOW_KLEIN_Ponte.jpg";
import kleinMark from "./../images/guitars/wow/klein/WOW_KLEIN_Meccaniche e marchio.jpg";
import spring from "./../images/guitars/roar/spring/ROAR_SPRING_principale.jpg";
import springMark from "./../images/guitars/roar/spring/Meccaniche.jpg";
import springTail from "./../images/guitars/roar/spring/Tailpiece.jpg";
import springWoods from "./../images/guitars/roar/spring/Legni.jpg";
import felipe from "./../images/guitars/slurp/felipe/SLURP_FELIPE_Principale.jpg";
import felipeNeck from "./../images/guitars/slurp/felipe/Manico.jpg";
import felipeName from "./../images/guitars/slurp/felipe/Nome.jpg";
import felipeBridge from "./../images/guitars/slurp/felipe/Pickup ponte.jpg";
import monoblocco from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_principale.jpg";
import monobloccoBridge from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Ponte.jpg";
import monobloccoNeck from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Giunzione manico.jpg";
import monobloccoWoods from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Legni.jpg";

const guitarCoverMap = {
  diapason,
  monoblocco,
  spring,
  tretrecinque,
  venere,
  felipe,
  mono,
  pinderbass,
  klein,
};

/**
 * Function to get guitar information based on the element name.
 * It retrieves the guitar data from the locale and constructs the necessary HTML elements.
 *
 * @param {string} elementName - The name of the guitar or series element.
 * @returns {object|null} - An object containing guitar information or null if not found.
 * @throws Will log a warning if no guitar is found for the given name.
 */
const getInfo = (elementName) => {
  let data = locale[elementName];

  if (!data) {
    for (const sectionKey of Object.keys(locale)) {
      const section = locale[sectionKey];
      if (section.guitars && Array.isArray(section.guitars)) {
        for (const guitarObj of section.guitars) {
          const guitarKey = Object.keys(guitarObj)[0];
          if (guitarKey.toLowerCase() === elementName.toLowerCase()) {
            data = guitarObj[guitarKey];
            break;
          }
        }
      }
      if (data) break;
    }
  }

  if (!data) {
    console.warn("[openModal]: No guitar found.", {
      name: elementName,
      data: data,
    });
    return null;
  }

  const images = [];
  let table = create("table");

  switch (elementName) {
    case "diapason":
      images.push(diapason, diapasonPickUp, diapasonBridge, diapasonKeyboard);
      break;
    case "tretrecinque":
      images.push(
        tretrecinque,
        tretrecinqueKeyboard,
        tretrecinquePickUp,
        tretrecinqueBridge,
      );
      break;
    case "venere":
      images.push(venere, venereBridge, venerePickUp, venereKeyboard);
      break;
    case "mono":
      images.push(mono, monoPickup, monoNeck, monoMark);
      break;
    case "pinderbass":
      images.push(pinderbass, pinderbassBridge, pinderbassWoods, pinderbassEq);
      break;
    case "klein":
      images.push(klein, kleinPickUp, kleinBridge, kleinMark);
      break;
    case "felipe":
      images.push(felipe, felipeNeck, felipeName, felipeBridge);
      break;
    case "monoblocco":
      images.push(
        monoblocco,
        monobloccoBridge,
        monobloccoNeck,
        monobloccoWoods,
      );
      break;
    case "spring":
      images.push(spring, springMark, springTail, springWoods);
      break;
    case "wow":
      images.push(klein, kleinPickUp, kleinBridge, kleinMark);
      break;
    case "roar":
      images.push(tretrecinque, springMark, venere, venereBridge, springWoods);
      break;
    case "boom":
      images.push(diapason, diapasonPickUp, monoblocco, monobloccoBridge);
      break;
    case "slurp":
      images.push(
        mono,
        monoPickup,
        pinderbass,
        pinderbassBridge,
        felipeName,
        felipeNeck,
      );
  }

  const swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      enabled: false,
    },
    // breakpoints: {
    //   640: {
    //     slidesPerView: 2,
    //   },
    //   900: {
    //     slidesPerView: 3,
    //   },
    // },
  });

  const swiperWrapper = select(".swiper-wrapper");
  swiperWrapper.innerHTML = ""; // reset

  for (const image of images.slice(1)) {
    const div = create("div");
    div.classList.add("swiper-slide");
    const img = create("img");
    img.src = image;
    img.alt = data.title;
    div.appendChild(img);
    swiperWrapper.appendChild(div);
  }

  swiper.update();

  Object.keys(data.dataSheet).forEach((key) => {
    const tr = create("tr");
    const th = create("th");
    const td = create("td");
    th.textContent = key;
    td.textContent = data.dataSheet[key];
    tr.appendChild(th);
    tr.appendChild(td);
    table.appendChild(tr);
  });

  return {
    title: data.title,
    description: data.description,
    dataSheet: data.dataSheet,
    images,
    table,
  };
};

const onOpenModal = (elName, options = { section: null, typology: null }) => {
  if (!elName || !options || !options.section) {
    return console.warn("[openModal]: No element or section provided.");
  }

  const title = select(".modal__title");
  const description = select(".modal__description");
  const dataSheet = select(".modal__data__sheet");
  const image = select(".modal__image");
  const swiper = select(".swiper");
  const seriesListContainer = select(".modal__series-list");

  // always reset
  title.innerHTML = "";
  description.innerHTML = "";
  dataSheet.innerHTML = "";
  image.innerHTML = "";
  if (seriesListContainer) seriesListContainer.innerHTML = "";

  // then create elements
  const h2 = create("h2");
  const p = create("p");
  const table = create("table");
  const img = create("img");

  let element = null;

  switch (options.section) {
    case "guitars":
      element = getInfo(elName);
      break;
    case "about":
      element = locale[elName] || locale.filosofy;
      break;
    default:
      console.warn("[openModal]: No section provided.");
      break;
  }

  if (!element) {
    console.warn("[openModal]: No element found for", elName);
    return;
  }

  h2.textContent = element.title ?? "";
  p.textContent = element.description ?? "";

  // Handle different data structures
  if (options.section === "about") {
    // For about section, hide data sheet, swiper and modal__image
    table.innerHTML = "";
    img.src = "";
    img.alt = element.title ?? "About Image";

    // Hide swiper and modal__image for about section
    if (swiper) swiper.style.display = "none";
    if (image) {
      image.style.display = "none";
      image.href = "#";
    }
  } else {
    // For guitars section
    table.innerHTML = element.table?.innerHTML ?? "";
    img.src = element.images?.[0] ?? "";
    img.alt = element.title ?? "Guitar Image";

    if (options.typology === "guitar") {
      // Hide swiper for individual guitars
      if (swiper) swiper.style.display = "none";
      if (image) {
        image.style.display = "";
        image.href = elName ? `./${elName}.html` : "#";
      }
    } else {
      // For series: hide modal__image, show swiper with cover images only
      if (image) {
        image.style.display = "none";
        image.style.cursor = "";
        image.onclick = null;
      }

      // Populate swiper with guitar cover images from the series
      const seriesKey = elName?.toLowerCase();
      const seriesData = locale[seriesKey];
      if (seriesData?.guitars && Array.isArray(seriesData.guitars) && swiper) {
        swiper.style.display = "";
        const swiperWrapper = select(".swiper-wrapper");
        if (swiperWrapper) {
          swiperWrapper.innerHTML = "";
          for (const guitarObj of seriesData.guitars) {
            const guitarKey = Object.keys(guitarObj)[0];
            const cover = guitarCoverMap[guitarKey];
            if (cover) {
              const div = create("div");
              div.classList.add("swiper-slide");
              div.style.cursor = "pointer";
              const coverImg = create("img");
              coverImg.src = cover;
              coverImg.alt = guitarKey;
              div.appendChild(coverImg);
              // On click, dispatch custom event for app.js to handle map navigation
              div.addEventListener("click", () => {
                document.dispatchEvent(
                  new CustomEvent("guitar-select", {
                    detail: { guitarName: guitarKey },
                  }),
                );
              });
              swiperWrapper.appendChild(div);
            }
          }
          // Re-init swiper
          const swiperInstance = new Swiper(".mySwiper", {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: true,
            centeredSlidesBounds: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              enabled: false,
            },
          });

          // Placeholder per swiper
          for (let i = 0; i < 2; i++) {
            const placeholder = create("div");
            placeholder.classList.add(
              "swiper-slide",
              "swiper-slide--placeholder",
            );
            swiperWrapper.appendChild(placeholder);
          }
          swiperInstance.update();
        }
      } else if (swiper) {
        swiper.style.display = "none";
      }
    }
    // if (options.typology === "series" && seriesListContainer) {
    //   console.log("entro", seriesListContainer);
    //   console.log("1. entro nel blocco series");
    //   const seriesKey = elName?.toLowerCase();
    //   const seriesData = locale[seriesKey];
    //   console.log("2. seriesData:", seriesData);

    //   if (seriesData?.guitars && Array.isArray(seriesData.guitars)) {
    //     console.log("3. guitars trovate:", seriesData.guitars.length);
    //     const wrapper = create("div");
    //     wrapper.classList.add("element__wrapper");
    //     const ul = create("ul");
    //     ul.classList.add("element__list");

    //     for (const guitarObj of seriesData.guitars) {
    //       const guitarKey = Object.keys(guitarObj)[0];
    //       const guitarData = guitarObj[guitarKey];
    //       const dataSheet = guitarData?.dataSheet || {};

    //       const a = create("a");
    //       a.href = `./${guitarKey}.html`;

    //       const li = create("li");
    //       li.classList.add("element__item");

    //       const summary = create("div");
    //       summary.classList.add("element__summary");

    //       const spanSeries = create("span");
    //       spanSeries.textContent = seriesKey;
    //       const spanTitle = create("span");
    //       spanTitle.textContent = guitarData?.title || guitarKey;
    //       const spanYear = create("span");
    //       spanYear.textContent = dataSheet.Anno || "";

    //       const cover = guitarCoverMap[guitarKey];
    //       if (cover) {
    //         const coverImg = create("img");
    //         coverImg.src = cover;
    //         coverImg.alt = guitarData?.title || guitarKey;
    //         summary.appendChild(spanSeries);
    //         summary.appendChild(spanTitle);
    //         summary.appendChild(spanYear);
    //         summary.appendChild(coverImg);
    //       } else {
    //         summary.appendChild(spanSeries);
    //         summary.appendChild(spanTitle);
    //         if (spanYear.textContent) summary.appendChild(spanYear);
    //       }

    //       li.appendChild(summary);
    //       a.appendChild(li);
    //       ul.appendChild(a);
    //     }

    //     // Placeholders for responsive design
    //     if (options.typology === "series") {
    //       for (let i = 0; i < 2; i++) {
    //         const placeholder = create("li");
    //         placeholder.classList.add(
    //           "element__item",
    //           "element__item--placeholder",
    //         );
    //         ul.appendChild(placeholder);
    //       }
    //     }
    //     wrapper.appendChild(ul);
    //     seriesListContainer.appendChild(wrapper);

    //     seriesListContainer.style.display = "none"; // Temporary hide
    //   }
    // }
  }

  title.appendChild(h2);
  description.appendChild(p);
  dataSheet.appendChild(table);
  image.appendChild(img);
};

export default onOpenModal;
